<wlx-tabs>
  <wlx-tab [title]="'profiles.search.advanced.contact-info.title' | translate | titlecase">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.contact-info.title' | translate | titlecase }}</h4>
      @for (searchExpression of profileAdvancedSearchParams.ContactInfoSearchExpressions; track $index;
      let i = $index) {
      <div class="form-group mct-flex mct-row mct-gap-10">
        <wl-expression class="mct-flex-1-1-0" [searchExpression]="searchExpression" [binarySelectorHidden]="i === 0">
          <wl-expression-option fieldName="ProfileId"
            [displayName]="'profiles.search.advanced.options.profileid' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="ASF"
            [displayName]="'profiles.search.advanced.options.sort-name' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="FirstName"
            [displayName]="'profiles.search.advanced.options.first-name' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="LastName"
            [displayName]="'profiles.search.advanced.options.last-name' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="Address1"
            [displayName]="'profiles.search.advanced.options.address1' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="Address2"
            [displayName]="'profiles.search.advanced.options.address2' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="City"
            [displayName]="'profiles.search.advanced.options.city' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="State"
            [displayName]="'profiles.search.advanced.options.state' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="Zip"
            [displayName]="'profiles.search.advanced.options.zip' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="County"
            [displayName]="'profiles.search.advanced.options.county' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="Country"
            [displayName]="'profiles.search.advanced.options.country' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="WorkPhone"
            [displayName]="'profiles.search.advanced.options.work-phone' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="HomePhone"
            [displayName]="'profiles.search.advanced.options.home-phone' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="Email"
            [displayName]="'profiles.search.advanced.options.email' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="Website"
            [displayName]="'profiles.search.advanced.options.website' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="PersonalTitle"
            [displayName]="'profiles.search.advanced.options.personal-title' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="ExternalId"
            [displayName]="'profiles.search.advanced.options.external-id' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="MembershipLevel"
            [displayName]="'profiles.search.advanced.options.membership-level' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="ProfileStatus"
            [displayName]="'profiles.search.advanced.options.profile-status' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="AssignedTo"
            [displayName]="'profiles.search.advanced.options.assigned-to' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="SoldBy"
            [displayName]="'profiles.search.advanced.options.sold-by' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="MemberSource"
            [displayName]="'profiles.search.advanced.options.member-source' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="EmployeesFT"
            [displayName]="'profiles.search.advanced.options.employees-ft' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="EmployeesPT"
            [displayName]="'profiles.search.advanced.options.employees-pt' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="MemberSince"
            [displayName]="'profiles.search.advanced.options.member-since' | translate | titlecase"
            [fieldType]="fieldTypeEnum.Date"></wl-expression-option>
          <wl-expression-option fieldName="DateChanged"
            [displayName]="'profiles.search.advanced.options.date-changed' | translate | titlecase"
            [fieldType]="fieldTypeEnum.Date"></wl-expression-option>
          <wl-expression-option fieldName="Customers"
            [displayName]="'profiles.search.advanced.options.customers' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="Member"
            [displayName]="'profiles.search.advanced.options.member' | translate | titlecase"
            [fieldType]="fieldTypeEnum.Bool"></wl-expression-option>
          <wl-expression-option fieldName="Prospect"
            [displayName]="'profiles.search.advanced.options.prospect' | translate | titlecase"
            [fieldType]="fieldTypeEnum.Bool"></wl-expression-option>
          <wl-expression-option fieldName="OrgIndicator"
            [displayName]="'profiles.search.advanced.options.org-indicator' | translate | titlecase"
            [fieldType]="fieldTypeEnum.Bool"></wl-expression-option>
          <wl-expression-option fieldName="PreferedContact"
            [displayName]="'profiles.search.advanced.options.prefered-contact' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="PreferredBillingMethod"
            [displayName]="'profiles.search.advanced.options.preferred-billing-method' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="CellPhone"
            [displayName]="'profiles.search.advanced.options.cell-phone' | translate | titlecase"></wl-expression-option>
          <wl-expression-option fieldName="DBA"
            [displayName]="'profiles.search.advanced.options.dba' | translate"></wl-expression-option>
          <wl-expression-option fieldName="NoEmail"
            [displayName]="'profiles.search.advanced.options.email-subscription-status' | translate | titlecase"
            [fieldType]="fieldTypeEnum.Bool"
            [trueLabel]="'profiles.search.advanced.options.opted-out' | translate | titlecase"
            [falseLabel]="'profiles.search.advanced.options.opted-in' | translate | titlecase"></wl-expression-option>
          <!--track customfieldid, datatype in fieldvalue so-->
          <wl-expression-option *ngFor="let customField of customFields"
            fieldName="CustomField|{{ customField.CustomFieldID }}|{{ customField.DataType }}"
            [fieldType]="customField.DataType" [displayName]="customField.Name"></wl-expression-option>
        </wl-expression>
        <div class="ps-adv-38px">
          <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-times"
            (click)="removeContactInfoSearchField(i)"></button>
        </div>
      </div>
      }
      <div class="form-group" style="margin-bottom: 40px">
        <button app-add-button dataCy="btnAddExpression"
          [label]="'profiles.search.advanced.add-search-field' | translate | titlecase"
          (click)="addContactInfoSearchField()"></button>
      </div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching" data-cy="btnProfileRunSearch">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.billing.title' | translate | titlecase" [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    "
    [dirty]="profileAdvancedSearchParams.BillingAnchorMonth > 0 || profileAdvancedSearchParams.BillingRevenueItemNum > 0">
    <div class="form-horizontal" style="margin-bottom: 40px">
      <h4>{{ 'profiles.search.advanced.billing.title' | translate | titlecase }}</h4>
      <div class="form-group mct-flex mct-row mct-wrap mct-gap-10" style="margin-bottom: 27px">
        <div class="ps-adv-150px">
          <label>
            {{ 'profiles.search.advanced.billing.billing-anchor-month' | translate | titlecase }}
          </label>
          <select [(ngModel)]="profileAdvancedSearchParams.BillingAnchorMonth" class="form-control">
            <option [value]="0">{{ 'common.select' | translate | titlecase }}...</option>
            <option [ngValue]="i" *ngFor="let month of months; let i = &quot;index+1&quot;">{{ month }}</option>
          </select>
        </div>
        <div class="ps-adv-250px">
          <label>
            {{ 'profiles.search.advanced.billing.billing-revenue-item' | translate | titlecase }}
          </label>
          <wl-revenue-item-selector noneValueDisplay="{{ 'common.select' | translate | titlecase }}..."
            [(ngModel)]="profileAdvancedSearchParams.BillingRevenueItemNum"></wl-revenue-item-selector>
        </div>
        <div class="ps-adv-150px">
          <label>
            {{ 'profiles.search.advanced.billing.billing-cycle' | translate | titlecase }}
          </label>
          <p-select placeholder="{{ 'common.select' | translate | titlecase }}" [options]="billingCycles"
            [(ngModel)]="profileAdvancedSearchParams.BillingCycle" appendTo="body" showClear name="billingCycle"
            [style]="{ 'border-radius': '0' }" optionLabel="Name" optionValue="Name"></p-select>
        </div>
      </div>
      <div class="form-group mb-27 mct-flex mct-row mct-wrap mct-gap-10">
        <div class="ps-adv-210px">
          <label>
            {{ 'profiles.search.advanced.billing.dues-amount' | translate | titlecase }} {{ 'common.between' | translate
            | titlecase }}
          </label>
          <div class="input-group">
            <div class="input-group-addon">$</div>
            <input type="number" [(ngModel)]="profileAdvancedSearchParams.DuesAmountMin" class="form-control" />
          </div>
        </div>
        <div class="ps-adv-210px">
          <label>
            {{ 'common.and' | translate | titlecase }}
          </label>
          <div class="input-group">
            <div class="input-group-addon">$</div>
            <input type="number" [(ngModel)]="profileAdvancedSearchParams.DuesAmountMax" class="form-control" />
          </div>
        </div>
      </div>
      <div class="form-group">
        <p-checkbox name="arbBillingsOnly" inputId="arbBillingsOnly"
          [(ngModel)]="profileAdvancedSearchParams.ArbBillingsOnly" [binary]="true"></p-checkbox>
        <label for="arbBillingsOnly">{{ 'profiles.search.advanced.billing.arb-billings-only' | translate }}</label>
      </div>
      <div class="form-group" [hidden]="true">
        <div class="mct-flex-1-1-0">
          <label>
            {{ 'profiles.search.advanced.billing.unpaid-dues-invoice-due-after' | translate | titlecase }}
          </label>
          <div class="input-group">
            <span class="input-group-addon">
              <input type="checkbox" [(ngModel)]="profileAdvancedSearchParams.UseUnpaidDuesAfter" />
            </span>
            <wl-date-selector [disabled]="!profileAdvancedSearchParams.UseUnpaidDuesAfter" class="input-group"
              [(ngModel)]="profileAdvancedSearchParams.UnpaidDuesAfter"></wl-date-selector>
          </div>
        </div>
      </div>
    </div>
    <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
      style="margin-right: -30px; margin-bottom: -70px">
      <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall">
        <strong>{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
      </button>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.member-activity.title' | translate | titlecase" [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    " [dirty]="profileAdvancedSearchParams.MemberActivitySearchExpressions.length > 0">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.member-activity.title' | translate | titlecase }}</h4>
      <div *ngFor="let searchExpression of profileAdvancedSearchParams.MemberActivitySearchExpressions; let i = index"
        class="form-group mct-flex mct-row mct-gap-10">
        <wl-expression [searchExpression]="searchExpression" [binarySelectorHidden]="i === 0" style="width: 100%">
          <wl-expression-option *ngFor="let activityType of memberActivityTypes; let i = &quot;index+1&quot;"
            [fieldName]="activityType.ActivityTypeID" [displayName]="activityType.ActivityType"
            [fieldType]="fieldTypeEnum.Date"></wl-expression-option>
        </wl-expression>
        <div class="ps-adv-38px">
          <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-times"
            (click)="removeMemberActivitySearchField(i)"></button>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 40px">
        <button app-add-button [label]="'profiles.search.advanced.add-search-field' | translate | titlecase"
          (click)="addMemberActivitySearchField()"></button>
      </div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall">
          <strong>{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.affiliation-codes.title' | translate | titlecase" [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    "
    [dirty]="profileAdvancedSearchParams.AffCodes.length > 0 || profileAdvancedSearchParams.ExcludeAffCodes.length > 0">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.affiliation-codes.title' | translate | titlecase }}</h4>
      <wl-affcode-selector #affCodeSelector [(ngModel)]="profileAdvancedSearchParams.AffCodes"
        ngModelChange="resetAffCodes()" [showAllOfOneOfOptions]="true"
        [(allOfSelected)]="profileAdvancedSearchParams.MatchAllAffCodes"></wl-affcode-selector>

      <div class="wl-profile-advance-search-exclude-affcode-container">
        <wl-affcode-selector #affCodeExcludeSelector [(ngModel)]="profileAdvancedSearchParams.ExcludeAffCodes"
          [allOfOneOfPromptLabel]="'affiliation.affcode-selector.all-of-one-of-not-default-prompt' | translate"
          [showAllOfOneOfOptions]="true"
          [(allOfSelected)]="profileAdvancedSearchParams.MatchAllExcludeAffCodes"></wl-affcode-selector>
      </div>
    </div>
    <div style="margin-bottom: 40px">&nbsp;</div>
    <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
      style="margin-right: -30px; margin-bottom: -70px">
      <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall">
        <strong>{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
      </button>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.categories.title' | translate | titlecase" [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    " [dirty]="profileAdvancedSearchParams.CategorySearchExpressions.length > 0">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.categories.title' | translate | titlecase }}</h4>
      <div *ngFor="let searchExpression of profileAdvancedSearchParams.CategorySearchExpressions; let i = index"
        class="search-expression-field">
        <div>
          <select [hidden]="i === 0" [(ngModel)]="searchExpression.BinaryOperator" class="form-control">
            <option [ngValue]="binaryOperatorEnum.And">
              {{ 'shared.widgets.expression.binary-operator.and' | translate | titlecase }}
            </option>
            <option [ngValue]="binaryOperatorEnum.Or">{{ 'shared.widgets.expression.binary-operator.or' | translate |
              titlecase }}</option>
          </select>
        </div>
        <div>
          <select [(ngModel)]="searchExpression.Value" class="form-control">
            <option *ngFor="let category of categories" [value]="category.Id">
              {{ category.Name }}
            </option>
          </select>
        </div>
        <div>
          <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-times"
            (click)="removeCategoriesSearchField(i)"></button>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 40px">
        <button app-add-button [label]="'profiles.search.advanced.add-search-field' | translate | titlecase"
          (click)="addCategoriesSearchField()"></button>
      </div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.events.title' | translate | titlecase" [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    " [dirty]="profileAdvancedSearchParams.EventsSearchExpressions.length > 0">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.events.title' | translate | titlecase }}</h4>
      <div *ngFor="let searchExpression of profileAdvancedSearchParams.EventsSearchExpressions; let i = index"
        class="form-group search-expression-field">
        <div class="">
          <select [hidden]="i === 0" [(ngModel)]="searchExpression.BinaryOperator" class="form-control">
            <option [ngValue]="binaryOperatorEnum.And">
              {{ 'shared.widgets.expression.binary-operator.and' | translate | titlecase }}
            </option>
            <option [ngValue]="binaryOperatorEnum.Or">{{ 'shared.widgets.expression.binary-operator.or' | translate |
              titlecase }}</option>
          </select>
        </div>
        <div>
          <select [(ngModel)]="searchExpression.Field" class="form-control">
            <option value="">{{ 'common.select' | translate | titlecase }}...</option>
            <option value="AttendeeForEvent">{{ 'common.attendee' | translate | titlecase }}</option>
            <option value="SignUpForEvent">{{ 'common.sign-up' | translate | titlecase }}</option>
            <option value="NotSignUpOrAttendeeForEvent">
              {{ 'profiles.search.advanced.not-a-signup-or-attendee' | translate | titlecase }}
            </option>
          </select>
        </div>
        <div>
          <label>{{ 'profiles.search.advanced.of-event-id' | translate }}:</label>
        </div>
        <div>
          <input [(ngModel)]="searchExpression.Value" class="form-control" />
        </div>
        <div>
          <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-times"
            (click)="removeEventsSearchField(i)"></button>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 40px">
        <button app-add-button [label]="'profiles.search.advanced.add-search-field' | translate | titlecase"
          (click)="addEventsSearchField()"></button>
      </div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.certifications.title' | translate | titlecase" [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    " [dirty]="profileAdvancedSearchParams.CertificationOptions?.length > 0">
    <h4>{{ 'profiles.search.advanced.certifications.title' | translate | titlecase }}</h4>
    <div class="form-horizontal">
      <div *ngFor="let certification of profileAdvancedSearchParams.CertificationOptions; let c = index">
        <hr [hidden]="c === 0" />
        <div>
          <div class="form-group search-expression-field">
            <div>
              <select [hidden]="c === 0" [(ngModel)]="certification.BinaryOperator" class="form-control">
                <option [ngValue]="binaryOperatorEnum.And">
                  {{ 'shared.widgets.expression.binary-operator.and' | translate | titlecase }}
                </option>
                <option [ngValue]="binaryOperatorEnum.Or">
                  {{ 'shared.widgets.expression.binary-operator.or' | translate | titlecase }}
                </option>
              </select>
            </div>
            <div>
              <label>
                {{ 'profiles.search.advanced.certifications.certification-type' | translate | titlecase }}
                <p-select (onChange)="certificationTypeChange($event, certification)"
                  [placeholder]="'common.select' | translate | titlecase" [options]="certificationTypes"
                  [(ngModel)]="certification.CertificationType" [disabled]="certification.CeuCreditType > 0"></p-select>
              </label>
            </div>
            <div>
              <label>
                {{ 'profiles.search.advanced.certifications.ceu-type' | translate }}
                <p-select (onChange)="ceuCreditTypeChange($event, certification)"
                  [placeholder]="'common.select' | translate | titlecase" [options]="ceuTypes"
                  [(ngModel)]="certification.CeuCreditType" [disabled]="certification.CertificationType > 0"></p-select>
              </label>
            </div>
            <div>
              <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-times"
                (click)="removeCertificationSearchField(c)"></button>
            </div>
          </div>
        </div>
        <div>
          <button app-add-button [label]="'profiles.search.advanced.add-search-field' | translate | titlecase"
            (click)="addCertificationSubSearchField(c)"></button>
        </div>
        <div *ngFor="let searchExpression of certification.SearchExpressions; let i = index"
          class="form-group search-expression-field">
          <wl-expression [searchExpression]="searchExpression" [binarySelectorHidden]="i === 0" style="width: 100%">
            <wl-expression-option fieldName="CertificationDate"
              [displayName]="'profiles.search.advanced.certifications.certification-date' | translate | titlecase"
              [fieldType]="fieldTypeEnum.Date"></wl-expression-option>
            <wl-expression-option fieldName="CeuDateEarned"
              [displayName]="'profiles.search.advanced.certifications.ceu-date-earned' | translate | titlecase"
              [fieldType]="fieldTypeEnum.Date"></wl-expression-option>
            <wl-expression-option fieldName="ExpirationDate"
              [displayName]="'profiles.search.advanced.certifications.expiration-date' | translate | titlecase"
              [fieldType]="fieldTypeEnum.Date"></wl-expression-option>
            <wl-expression-option fieldName="RenewalDate"
              [displayName]="'profiles.search.advanced.certifications.renewal-date' | translate | titlecase"
              [fieldType]="fieldTypeEnum.Date"></wl-expression-option>
          </wl-expression>
          <div>
            <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-times"
              (click)="removeCertificationSubSearchField(c, i)"></button>
          </div>
        </div>
      </div>
      <div class="form-group" class="mt-27 mb-27">
        <button app-add-button
          [label]="'profiles.search.advanced.certifications.add-certification-search' | translate | titlecase"
          (click)="addCertificationSearchField()"></button>
      </div>
    </div>
    <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
      style="margin-right: -30px; margin-bottom: -70px">
      <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall" [disabled]="isSearching">
        <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' | translate
          | uppercase }}</strong>
        <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
      </button>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.related-profiles.title' | translate | titlecase" [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    " [dirty]="
      profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior != 0 ||
      profileAdvancedSearchParams.RelatedProfileOptions.MainContact ||
      profileAdvancedSearchParams.RelatedProfileOptions.BillingContact ||
      profileAdvancedSearchParams.RelatedProfileOptions.Editor ||
      profileAdvancedSearchParams.RelatedProfileOptions.ReceivesCommunication ||
      profileAdvancedSearchParams.RelatedProfileOptions.PrimaryRelationship ||
      profileAdvancedSearchParams.RelatedProfileOptions.UseRelatedAs
    ">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.related-profiles.title' | translate | titlecase }}</h4>
      <div class="form-group" style="margin-bottom: 27px">
        {{ 'profiles.search.advanced.related-profiles.info' | translate | titlecase }}
      </div>
      <div class="form-group">
        <div class="mct-flex mct-row mct-wrap mct-gap-10 mct-flex-0-0-50pct ps-adv-full-lt-md">
          <div class="mct-flex-1-1-0">
            <label>
              <input name="resultOptions" [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior"
                [value]="1" type="radio" />
              {{ 'profiles.search.advanced.related-profiles.filter-results' | translate | titlecase }}
            </label>
          </div>
          <div class="mct-flex-1-1-0">
            <label>
              <input name="resultOptions" [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior"
                [value]="0" type="radio" />
              {{ 'profiles.search.advanced.related-profiles.add-results' | translate | titlecase }}
            </label>
          </div>
          <div class="mct-flex-1-1-0">
            <label>
              <input name="resultOptions" [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior"
                [value]="2" type="radio" />
              {{ 'profiles.search.advanced.related-profiles.replace-results' | translate | titlecase }}
            </label>
          </div>
        </div>
        <div class="mct-flex-0-0-50pct mct-hide-lt-md">&nbsp;</div>
      </div>
      <div class="form-group" style="margin-top: 54px">
        <div class="mct-flex mct-col mct-wrap mct-gap-12 mct-flex-0-0-50pct ps-adv-full-lt-md">
          <div>
            <label>
              <input [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.MainContact" type="checkbox" />
              {{ 'profiles.search.advanced.related-profiles.main-contact-label' | translate | titlecase }}
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior == 1">
                {{ 'profiles.search.advanced.related-profiles.of-results' | translate | titlecase }}
              </span>
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior != 1">
                {{ 'profiles.search.advanced.related-profiles.of-member' | translate | titlecase }}
              </span>
            </label>
          </div>
          <div>
            <label>
              <input [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.ReceivesCommunication"
                type="checkbox" />
              {{ 'profiles.search.advanced.related-profiles.receives-communication-label' | translate | titlecase }}
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior == 1">
                {{ 'profiles.search.advanced.related-profiles.of-results' | translate | titlecase }}
              </span>
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior != 1">
                {{ 'profiles.search.advanced.related-profiles.of-member' | translate | titlecase }}
              </span>
            </label>
          </div>
          <div>
            <label>
              <input [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.PrimaryRelationship"
                type="checkbox" />
              {{ 'profiles.search.advanced.related-profiles.primary-relation-label' | translate | titlecase }}
            </label>
          </div>
          <div>
            <label>
              <input [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.BillingContact" type="checkbox" />
              {{ 'profiles.search.advanced.related-profiles.billing-contact-label' | translate | titlecase }}
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior == 1">
                {{ 'profiles.search.advanced.related-profiles.of-results' | translate | titlecase }}
              </span>
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior != 1">
                {{ 'profiles.search.advanced.related-profiles.of-member' | translate | titlecase }}
              </span>
            </label>
          </div>
          <div>
            <label>
              <input [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.Editor" type="checkbox" />
              {{ 'profiles.search.advanced.related-profiles.editor-label' | translate | titlecase }}
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior == 1">
                {{ 'profiles.search.advanced.related-profiles.of-results' | translate | titlecase }}
              </span>
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior != 1">
                {{ 'profiles.search.advanced.related-profiles.of-member' | translate | titlecase }}
              </span>
            </label>
          </div>
          <div>
            <label>
              <input [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.UseRelatedAs" type="checkbox" />
              {{ 'profiles.search.advanced.related-profiles.related-as-1-label' | translate | titlecase }}
              <p-select [options]="relationTypes"
                [(ngModel)]="profileAdvancedSearchParams.RelatedProfileOptions.RelatedAs" optionLabel="RelationType"
                optionValue="RelationTypeId" [placeholder]="'common.select' | translate | titlecase"></p-select>
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior == 1">
                {{ 'profiles.search.advanced.related-profiles.of-results' | translate | titlecase }}
              </span>
              <span [hidden]="profileAdvancedSearchParams.RelatedProfileOptions.ResultBehavior != 1">
                {{ 'profiles.search.advanced.related-profiles.of-member' | translate | titlecase }}
              </span>
            </label>
          </div>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 40px">&nbsp;</div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.common-data-views.title' | translate | titlecase"
    [enabled]="!profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.common-data-views.title' | translate | titlecase }}</h4>
      <div class="form-group" style="margin-bottom: 27px">
        <div style="color: #d90000">
          {{ 'profiles.search.advanced.common-data-views.criteria-restriction' | translate }}
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 27px">
        <div>
          {{ 'profiles.search.advanced.common-data-views.select-one' | translate }}
        </div>
      </div>
      <div class="form-group">
        <div>
          <wl-common-data-view-selector cssClass="form-control" [(ngModel)]="profileAdvancedSearchParams.CommonDataView"
            [prompt]="('common.select' | translate | titlecase) + '...'"></wl-common-data-view-selector>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 40px">&nbsp;</div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab *ngIf="hasVoterVoice" [title]="'profiles.search.advanced.voter-voice.title' | translate"
    (selected)="handleVoterVoiceTabSelected()"
    [enabled]="!profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.UseSql">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.voter-voice.title' | translate | titlecase }}</h4>
      <div *ngIf="voterVoiceDataLoading"><wl-busy [show]="true"></wl-busy> {{ 'common.loading' | translate | titlecase
        }}</div>
      <div *ngIf="!voterVoiceDataLoading">
        <div class="form-group">
          <div class="col-sm-12">
            <button app-add-button [label]="'profiles.search.advanced.add-search-field' | translate | titlecase"
              (click)="addVoterVoiceSearchField()"></button>
          </div>
        </div>
        <div *ngFor="let searchExpression of profileAdvancedSearchParams.VoterVoicehExpressions; let i = index"
          class="form-group">
          <div class="col-sm-2">
            <select [hidden]="i == 0" [(ngModel)]="searchExpression.BinaryOperator" class="form-control">
              <option [value]="0">{{ 'shared.widgets.expression.binary-operator.and' | translate | titlecase }}</option>
              <option [value]="1">{{ 'shared.widgets.expression.binary-operator.or' | translate | titlecase }}</option>
            </select>
          </div>
          <div class="col-sm-4">
            <select [(ngModel)]="searchExpression.Field" class="form-control"
              (change)="handleVoterVoiceFieldChange(searchExpression)">
              <option value="">{{ 'common.select' | translate | titlecase }}...</option>
              <option value="Office">{{ 'profiles.search.advanced.voter-voice.field-name.office' | translate | titlecase
                }}</option>
              <option value="Official">{{ 'profiles.search.advanced.voter-voice.field-name.official' | translate |
                titlecase }}</option>
            </select>
          </div>
          <div class="col-sm-2">
            <select [(ngModel)]="searchExpression.FieldValueOperator" class="form-control">
              <option [value]="0">{{ 'shared.widgets.expression.value-operator.equals' | translate | titlecase }}
              </option>
              <option [value]="2">{{ 'shared.widgets.expression.value-operator.not-equal' | translate | titlecase }}
              </option>
            </select>
          </div>
          <div class="col-sm-3">
            <select class="form-control" *ngIf="searchExpression.Field == 'Office'"
              [(ngModel)]="searchExpression.Value">
              <option value="">{{ 'common.select' | translate | titlecase }}...</option>
              <option *ngFor="let office of voterVoiceOffices" [value]="office.OfficeUniqueId">
                {{ office.electedBody }} {{ office.electoralDistrict }}
              </option>
            </select>
            <select class="form-control" *ngIf="searchExpression.Field == 'Official'"
              [(ngModel)]="searchExpression.Value">
              <option value="">{{ 'common.select' | translate | titlecase }}...</option>
              <option *ngFor="let official of voterVoiceOfficials" [value]="official.OfficialUniqueId">{{
                official.displayName }}</option>
            </select>
          </div>
          <div class="col-sm-1">
            <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-times"
              (click)="removeVoterVoiceSearchField(i)"></button>
          </div>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 40px">&nbsp;</div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSeaching">
          <wl-busy [hidden]="!isSearching"></wl-busy>
          <strong [hidden]="!isSearching">{{ 'common.searching' | translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.my-data-views.title' | translate | titlecase"
    [enabled]="!profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.UseSql">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.my-data-views.title' | translate | titlecase }}</h4>
      <div class="form-group" style="margin-bottom: 27px">
        <div>
          {{ 'profiles.search.advanced.my-data-views.select-one' | translate | titlecase }}
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 27px">
        <div>
          <select [(ngModel)]="profileAdvancedSearchParams.DataViewId" class="form-control">
            <option value="0">{{ 'common.select' | translate | titlecase }}...</option>
            <option *ngFor="let dataView of dataViews" [value]="dataView.DataViewId">{{ dataView.Descr }}</option>
          </select>
        </div>
      </div>
      <div class="form-group" [hidden]="profileAdvancedSearchParams.DataViewId > 0">
        <div>
          <button pButton type="button" class="atlas-btn atlas-btn-default" [icon]="showSaveSearch ? 'pi pi-times' : 'pi pi-save'"
            [label]="
              (showSaveSearch
                ? 'profiles.search.advanced.my-data-views.cancel-save-label'
                : 'profiles.search.advanced.my-data-views.save-search-label'
              )
                | translate
                | titlecase
            " (click)="toggleSaveElement()"></button>
        </div>
      </div>
      <div class="form-group" [hidden]="profileAdvancedSearchParams.DataViewId == 0">
        <div>
          <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="toggleDeleteElement()">
            <span> {{ 'profiles.search.advanced.my-data-views.delete-selected-data-view' | translate | titlecase
              }}</span>
          </button>
        </div>
      </div>
      <div class="form-group" [hidden]="!showSaveSearch || profileAdvancedSearchParams.DataViewId > 0">
        <div class="col-sm-12">
          <input class="form-control" [(ngModel)]="searchName"
            [placeholder]="'profiles.search.advanced.my-data-views.search-name-placeholder' | translate | titlecase" />
        </div>
        <div class="col-sm-12">
          <label>
            <input type="checkbox" [(ngModel)]="allUsers" />
            {{ 'profiles.search.advanced.my-data-views.all-users-label' | translate | titlecase }}
          </label>
        </div>
        <div class="col-sm-12">
          <button pButton type="button" class="atlas-btn atlas-btn-primary" icon="pi pi-save"
            [disabled]="!searchName || savingSearch" [label]="'common.save' | translate | titlecase"
            (click)="saveSearch()"></button>
          <wl-busy [show]="savingSearch"></wl-busy>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 40px">&nbsp;</div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab *ngIf="nahbTabVisible"
    [title]="'profiles.search.advanced.nahb-membership-types.title' | translate | titlecase" [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    ">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.nahb-membership-types.title' | translate | titlecase }}</h4>
      <wl-list-builder #memberTypeListBuilder displayMember="Descr" valueMember="Code"
        [(ngModel)]="profileAdvancedSearchParams.NahbMemberTypes" [availableValues]="nahbMemberTypes"></wl-list-builder>
      <div class="form-group" style="margin-bottom: 40px">&nbsp;</div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab *ngIf="nahbTabVisible"
    [title]="'profiles.search.advanced.nahb-business-activities.title' | translate | titlecase" [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    ">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.nahb-business-activities.title' | translate | titlecase }}</h4>
      <wl-list-builder #busActivityListBuilder displayMember="Descr" valueMember="Code"
        [(ngModel)]="profileAdvancedSearchParams.NahbBusinessActivities"
        [availableValues]="nahbBusinessActivity"></wl-list-builder>
      <div class="form-group" style="margin-bottom: 40px">&nbsp;</div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab *ngIf="naaTabVisible" [title]="'profiles.search.advanced.naa-profile-types.title' | translate | titlecase"
    [enabled]="
      !profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId && !profileAdvancedSearchParams.UseSql
    ">
    <div class="form-horizontal">
      <h4>{{ 'profiles.search.advanced.naa-profile-types.title' | translate | titlecase }}</h4>
      <wl-list-builder #profileTypeListBuilder displayMember="Name" valueMember="Id"
        [(ngModel)]="profileAdvancedSearchParams.NaaProfileTypes" [availableValues]="naaProfileTypes"></wl-list-builder>
      <div class="form-group" style="margin-bottom: 40px">&nbsp;</div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'common.advanced' | translate | titlecase"
    [enabled]="!profileAdvancedSearchParams.CommonDataView && !profileAdvancedSearchParams.DataViewId">
    <div class="form-horizontal">
      <h4>{{ 'common.advanced' | translate | titlecase }}</h4>
      <div style="margin-bottom: 27px; color: #d90000">
        {{ 'profiles.search.advanced.advanced.criteria-restriction' | translate }}
      </div>
      <div style="margin-bottom: 27px">
        <label>
          <input type="checkbox" [(ngModel)]="profileAdvancedSearchParams.UseSql" />
          {{ 'profiles.search.advanced.advanced.use-sql-label' | translate }}
        </label>
      </div>
      <div style="margin-bottom: 27px">
        <textarea [disabled]="!profileAdvancedSearchParams.UseSql"
          [(ngModel)]="profileAdvancedSearchParams.SqlWhereClause" style="height: 100%; width: 100%"></textarea>
      </div>
      <div class="form-group" style="margin-bottom: 40px">&nbsp;</div>
      <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
        style="margin-right: -30px; margin-bottom: -70px">
        <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall"
          [disabled]="isSearching">
          <strong [hidden]="!isSearching"><wl-busy [show]="isSearching"></wl-busy>&nbsp;{{ 'common.searching' |
            translate | uppercase }}</strong>
          <strong [hidden]="isSearching">{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
        </button>
      </div>
    </div>
  </wlx-tab>
  <wlx-tab [title]="'profiles.search.advanced.forms.title' | translate | titlecase">
    <div class="form-horizontal" style="margin-bottom: 40px">
      <h4>{{ 'profiles.search.advanced.forms.title' | translate | titlecase }}</h4>
      <div *ngFor="let formSearch of profileAdvancedSearchParams.FormSearchExpressions; let i = index">
        <hr [hidden]="i === 0" />
        <div>
          <div class="form-group search-expression-field">
            <div>
              <select [hidden]="i === 0" [(ngModel)]="formSearch.BinaryOperator" class="form-control">
                <option [ngValue]="binaryOperatorEnum.And">
                  {{ 'shared.widgets.expression.binary-operator.and' | translate | titlecase }}
                </option>
                <option [ngValue]="binaryOperatorEnum.Or">
                  {{ 'shared.widgets.expression.binary-operator.or' | translate | titlecase }}
                </option>
              </select>
            </div>
            <div>
              <label>
                {{ 'profiles.search.advanced.forms.select-form' | translate | titlecase }}
                <p-select [placeholder]="'common.select' | translate | titlecase" [options]="formsList"
                  [(ngModel)]="formSearch.FormId"></p-select>
              </label>
            </div>
            <div>
              <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-times" *ngIf="i > 0"
                (click)="removeFormSearchField(i)"></button>
            </div>
          </div>
        </div>
        <div>
          <button app-add-button [label]="'profiles.search.advanced.add-search-field' | translate | titlecase"
            (click)="addFormSearchSubSearchField(i)"></button>
        </div>
        <div *ngFor="let searchExpression of formSearch.SearchExpressions; let i2 = index"
          class="form-group search-expression-field">
          <wl-expression [searchExpression]="searchExpression" [excludeExtraDateOptions]="true"
            [binarySelectorHidden]="i2 === 0" style="width: 100%">
            <wl-expression-option fieldName="FormSubmissionDate"
              [displayName]="'profiles.search.advanced.forms.forms-date' | translate | titlecase"
              [fieldType]="fieldTypeEnum.Date"></wl-expression-option>
            <wl-expression-option fieldName="FormSubmitted"
              [displayName]="'profiles.search.advanced.forms.forms-submitted' | translate | titlecase"
              [fieldType]="fieldTypeEnum.Bool"></wl-expression-option>
          </wl-expression>
          <div>
            <button pButton type="button" class="atlas-btn atlas-btn-default" icon="pi pi-times"
              (click)="removeFormSearchSubSearchField(i, i2)"></button>
          </div>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 40px">
        <button app-add-button dataCy="btnAddFormSearchField" class="mt-27 mb-27"
          [label]="'profiles.search.advanced.forms.add-search-field' | translate | titlecase"
          (click)="addFormSearchField()"></button>
      </div>
    </div>
    <div class="mct-flex mct-justify-end mct-items-center" [hidden]="hideRunThisSearchButton"
      style="margin-right: -30px; margin-bottom: -70px">
      <button pButton type="button" (click)="emitSearch()" class="atlas-btn atlas-btn-primary tall">
        <strong>{{ 'profiles.search.run-search' | translate | uppercase }}</strong>
      </button>
    </div>
  </wlx-tab>
</wlx-tabs>

<p-confirmDialog #cd key="deleteDataViewCD"
  header="{{ 'profiles.search.advanced.my-data-views.delete-selected-data-view' | translate | ucfirst }}?"
  icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
